import { VideoType } from '@core/enums/video.enums'

export enum VideoTypeMap {
  Tv = VideoType.Tv as any,
  Panoramic = VideoType.Panoramic as any,
  Tac = VideoType.Tactical as any,
  Live = VideoType.Live as any
}
